import * as Yup from "yup";
import { MeasurementTypes } from "../types/measurment";

// Desc: Measurment formik validation schema
const MeasurementSchema = Yup.object().shape({
  changeIdea: Yup.string(),
  name: Yup.string().required("Measurment name is Required"),
  dataType: Yup.string().required("Datatype is Required"),
  measurmentType: Yup.string().required("Measurement type is Required"),
  numerator: Yup.string().when("dataType", ([dataType], schema) => {
    return dataType === "Percentage"
      ? schema.required("Numerator is Required.")
      : schema;
  }),
  denominator: Yup.string().when("dataType", ([dataType], schema) => {
    return dataType === "Percentage"
      ? schema.required("Denominator is Required.")
      : schema;
  }),
  numericValue: Yup.string().when("dataType", ([dataType], schema) => {
    return dataType === "Numerical"
      ? schema.required("Numeric is Required.")
      : schema;
  }),
  frequency: Yup.string().required("Frequency is Required"),
  target: Yup.string().required("Target is Required"),
  baseline: Yup.string().required("Baseline is Required"),
});

export const measurmentFormik = {
  validateOnChange: false,
  validateOnBlur: false,
  initialValues: {
    changeIdea: "",
    measurmentType: MeasurementTypes.Process,
    name: "",
    dataType: "",
    numerator: "",
    denominator: "",
    numericValue: "",
    frequency: "",
    target: "",
    baseline: "",
  },
  validationSchema: MeasurementSchema,
  onSubmit: (values: any) => {
    console.log("values: ", values);
  },
};
